import React, { useRef } from "react";

import Box from "@mui/material/Box";
import FolderIcon from "@mui/icons-material/Folder";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import { Card } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import SidebarView, { SidebarRef } from "../common/Sidebar";
import CardView from "./components/Card";
import EpisodesList from "./components/EpisodesList";
import { dashboardService } from "./services";
import Headerbar from "../common/Headerbar";
import Breadcrumbs from "../common/Breadcrumbs";

export default function DashboardView() {
  const globalTheme = useTheme();
  const mobile = useMediaQuery(globalTheme.breakpoints.down("md"));

  const sidebarRef = useRef<SidebarRef>(null);
  const handleMobileMenuToggle = () => {
    sidebarRef.current?.toggleMobile();
  };

  const { data } = useQuery({
    queryKey: ["dashboard-stats"],
    queryFn: () => dashboardService.fetchDashboardStats(),
  });

  const { data: projectData, refetch: refetchProjects } = useQuery({
    queryKey: ["projects"],
    queryFn: () => dashboardService.fetchProjects(),
  });

  const px = mobile ? 2 : 4;

  return (
    <>
      <SidebarView ref={sidebarRef} pageName="Episodes" />
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[50]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <Headerbar
          pageName="Episodes"
          onMobileMenuClick={handleMobileMenuToggle}
        />
        <Breadcrumbs
          items={[
            {
              label: "Episodes",
              path: "/episodes",
              icon: <PlaylistPlayIcon sx={{ fontSize: 18 }} />,
            },
          ]}
          showHome={false}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: `${mobile ? "column" : "row"}`,
            flexFlow: `${mobile ? "none" : "wrap"}`,
            boxSizing: "border-box",
            marginTop: 6,
            paddingX: 8,
            paddingTop: 0,
            justifyContent: "center",
            gap: 2,
          }}
        >
          <CardView
            Icon={FolderIcon}
            title="Projects"
            value={data?.number_of_projects || 0}
            color="#1278c7"
            disabled={false}
          />
          <CardView
            Icon={AccessTimeIcon}
            title="Total minutes"
            value={data?.total_episodes_length_in_minutes || 0}
            color="#ebac6e"
            disabled={false}
          />
          <CardView
            Icon={PlaylistPlayIcon}
            title="Episodes"
            value={data?.number_of_episodes || 0}
            color="#63bf47"
            disabled={false}
          />
          <CardView
            Icon={FolderSharedIcon}
            title="Shared Episodes"
            value={data?.number_of_shared_projects || 0}
            color="#6ebbeb"
            disabled
          />
        </Box>
        <Card
          sx={{
            position: "relative",
            px,
            py: 2,
            marginY: 4,
            marginX: px,
            overflow: "visible",
            backgroundColor: "transparent",
            borderRadius: 0,
            boxShadow: "none",
            border: "none",
          }}
        >
          <EpisodesList
            projects={projectData?.projects}
            refetchProjects={refetchProjects}
          />
        </Card>
      </Box>
    </>
  );
}
